import { useEffect } from "react";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Hero from "./sections/Hero";
import About from "./sections/About";
import FeaturedVideo from "./sections/FeaturedVideo";
import Services from "./sections/Services";
import Rescue from "./sections/Rescue";
import Defence from "./sections/Defence";
import Industries from "./sections/Industries";
import Cases from "./sections/Cases";
import Insights from "./sections/Insights";
import Contact from "./sections/Contact";

export default function App() {
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const id = hash.replace("#", "");
    const attemptScroll = (attemptsLeft: number) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
      if (attemptsLeft > 0) {
        setTimeout(() => attemptScroll(attemptsLeft - 1), 100);
      }
    };
    setTimeout(() => attemptScroll(10), 120);
  }, []);

  return (
    <>
      <Nav route="home" />
      <Hero />
      <About />
      <FeaturedVideo />
      <Services />
      <Rescue />
      <Defence />
      <Industries />
      <Cases />
      <Insights />
      <Contact />
      <Footer />
    </>
  );
}
